import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import Lottie from 'lottie-react';

// Context //
import { useLanguage } from '../../../Context/LanguageContext';
// Context //

// Model //
import CalculationFomulaModal from './CalculationFormulaModal';
import MemberList from './MemberList';
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation //

// Image //
import ReRegistrationImagePath from '../../../image/ReRegistration.png';
import LeaveMemberImagePath from '../../../image/LeaveMember.png';
// Image //


const MemberMovementHistoryBox = (props) => {
  const {
    salesData,
    startDate,
    endDate,
    calcDateText,
    allMembers,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isLoadingAllMember,
    isReregistLoading,
    setIsReregistLoading,
    isExpiredLoading,
    setIsExpiredLoading
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [reRegistMembers, setReRegistMembers] = useState([]);
  const [aliveMembers, setAliveMembers] = useState([]);
  const [leaveMembers, setLeaveMembers] = useState([]);
  const [reregistPrice, setReregistPrice] = useState(0);
  const [isViewLeaveMemberRateModal, setIsViewLeaveMemberRateModal] = useState(false);
  const [isViewReregistMemberRateModal, setIsViewReregistMemberRateModal] = useState(false);

  // 이탈 회원, 재등록 회원 구분 //
  useEffect(() => {
    if (isLoadingAllMember) return;

    let newReregistMembers = [];
    let newAliveMembers = [];
    let newLeaveMembers = [];

    for (let i = 0; i < allMembers.length; i++) {
      let isReregist = false;
      let isAlive = false;
      let isLeave = false;

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].startDate) || startDate.isSame(allMembers[i].usages[j].startDate))
          && (endDate.isAfter(allMembers[i].usages[j].startDate) || endDate.isSame(allMembers[i].usages[j].startDate))
          && allMembers[i].usages.length > 1) {
          allMembers[i].startDate = allMembers[i].usages[j].startDate;
          isReregist = true;
          break;
        }
      }

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if (endDate.isBefore(allMembers[i].usages[j].endDate)) {
          isAlive = true;
          break;
        }
      }

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if (j === allMembers[i].usages.length - 1
          && startDate.isBefore(allMembers[i].usages[j].endDate)
          && endDate.isAfter(allMembers[i].usages[j].endDate)) {
          allMembers[i].endDate = allMembers[i].usages[j].endDate;
          isLeave = true;
          break;
        }
      }

      if (isReregist) newReregistMembers.push(allMembers[i]);
      if (isAlive) newAliveMembers.push(allMembers[i]);
      if (isLeave) newLeaveMembers.push(allMembers[i]);
    }

    newReregistMembers.sort(function (a, b) {
      let x = a.startDate;
      let y = b.startDate;

      if (x < y) return 1;
      if (x > y) return -1;
    })

    newLeaveMembers.sort(function (a, b) {
      let x = a.endDate;
      let y = b.endDate;

      if (x < y) return 1;
      if (x > y) return -1;
    })

    setReRegistMembers(newReregistMembers);
    setAliveMembers(newAliveMembers);
    setLeaveMembers(newLeaveMembers);

    setTimeout(() => {
      setIsReregistLoading(false);
      setIsExpiredLoading(false);
    }, 1000)
  }, [startDate, endDate, allMembers, isLoadingAllMember])

  useEffect(() => {
    if (salesData.length === 0 || allMembers.length === 0) return;

    let reRegistMembers = [];
    let newReregistPrice = 0;

    for (let i = 0; i < allMembers.length; i++) {
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].approvalDate) || startDate.isSame(allMembers[i].usages[j].approvalDate))
          && (endDate.isAfter(allMembers[i].usages[j].approvalDate) || endDate.isSame(allMembers[i].usages[j].approvalDate))
          && allMembers[i].usages.length > 1) {
          reRegistMembers.push(allMembers[i]);
          break;
        }
      }
    }

    for (let i = 0; i < salesData.length; i++) {
      let isExist = false;

      for (let j = 0; j < reRegistMembers.length; j++) {
        if (salesData[i].memberId === reRegistMembers[j].memberId) {
          isExist = true;
          break;
        }
      }

      if (isExist) {
        newReregistPrice += (salesData[i].cardPrice + salesData[i].cashPrice);
      }

    }

    setReregistPrice(newReregistPrice);
  }, [salesData, allMembers])

  // 회원 이탈율 호버링시 //
  function onMouseOverLeaveMemberRate() {
    setIsViewLeaveMemberRateModal(true);
  }

  // 회원 이탈율 호버링시 //
  function onMouseLeaveLeaveMemberRate() {
    setIsViewLeaveMemberRateModal(false);
  }

  // 회원 재등록율 호버링시 //
  function onMouseOverReregistMemberRate() {
    setIsViewReregistMemberRateModal(true);
  }

  // 회원 재등록율 호버링시 //
  function onMouseLeaveReregistMemberRate() {
    setIsViewReregistMemberRateModal(false);
  }


  return (
    <TopLevelWrapper $isDark={isDark}>
      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{calcDateText() + ' ' + t('statistics.memberMovement.leavingMembers')}</Text>
        {
          isExpiredLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <LeaveIcon src={LeaveMemberImagePath} />
                      <LeavePersent onMouseOver={onMouseOverLeaveMemberRate} onMouseLeave={onMouseLeaveLeaveMemberRate}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('statistics.memberMovement.churnRate')}</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{Math.round((leaveMembers.length / aliveMembers.length) * 100)}%</Text>
                      </LeavePersent>
                      <CalculationFomulaModal
                        isView={isViewLeaveMemberRateModal}
                        denominator={leaveMembers.length.toLocaleString('ko-KR')}
                        denominatorText={t('statistics.memberMovement.formulaNumerator')}
                        numerator={aliveMembers.length.toLocaleString('ko-KR')}
                        numeratorText={t('statistics.memberMovement.formulaDenominator')}
                        result={Math.round((leaveMembers.length / aliveMembers.length) * 100)}
                        resultUnit='%'
                        innerBoxBackgroundColor='#C15D24'
                        componentBoxBackgroundColor='#FF8B48' />
                      <DivisionLine />
                      <ResultBox>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.total')}</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subText} cursor='default'>{leaveMembers.length}{t('statistics.personUnit')}</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.churned')}</Text>
                      </ResultBox>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.churnedMemberList')}</Text>
                    </ListTitleWrapper>
                    <MemberList column={t('statistics.memberMovement.leavingDate')} data={leaveMembers} selectedPartnerGym={selectedPartnerGym} />
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>

      <BoxDivisionLine />

      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{calcDateText() + ' ' + t('statistics.maintainMember.newRegisteredMembers')}</Text>
        {
          isReregistLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <LeaveIcon src={ReRegistrationImagePath} />
                      <ReRegistrationPersent onMouseOver={onMouseOverReregistMemberRate} onMouseLeave={onMouseLeaveReregistMemberRate}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('statistics.memberMovement.reRegistrationRate')}</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{Math.round((reRegistMembers.length / aliveMembers.length) * 100)}%</Text>
                      </ReRegistrationPersent>
                      <CalculationFomulaModal
                        isView={isViewReregistMemberRateModal}
                        denominator={reRegistMembers.length.toLocaleString('ko-KR')}
                        denominatorText={t('statistics.memberMovement.reRegistrationNumerator')}
                        numerator={aliveMembers.length.toLocaleString('ko-KR')}
                        numeratorText={t('statistics.memberMovement.formulaDenominator')}
                        result={Math.round((reRegistMembers.length / aliveMembers.length) * 100)}
                        resultUnit='%'
                        innerBoxBackgroundColor='#4195C3'
                        componentBoxBackgroundColor='#65C5FA' />
                      <DivisionLine />
                      <ResultBox>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.total')}</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subText} cursor='default'>{reRegistMembers.length}{t('statistics.personUnit')}</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.reRegistered')}</Text>
                      </ResultBox>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.reRegisteredMemberList')}</Text>
                      <PriceTextWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.memberMovement.reRegisteredMemberSales')}</Text>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{reregistPrice.toLocaleString('ko-KR')}</Text>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.won')}</Text>
                      </PriceTextWrapper>
                    </ListTitleWrapper>
                    <MemberList column={t('statistics.memberMovement.registrationDate')} data={reRegistMembers} selectedPartnerGym={selectedPartnerGym} />
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default MemberMovementHistoryBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 38px;
  
  width: 1020px;
  height: 448px;

  gap: 28px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const BoxDivisionLine = styled.div`
  diplay: flex;
  flex-direction: row;

  width: 1px;
  height: 392px;

  background-color: ${props => props.theme.line};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;

  width: 44.5%;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 364px;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
  height: 364px;

  z-index: 5;

  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const TopUIWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

const LeaveIcon = styled.img`
  width: 48px;
  height: 48px;

  margin-right: 8px;
`;

const LeavePersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: ${props => props.theme.primary};

  &:hover {
    cursor: pointer;
  }
`;

const ReRegistrationPersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  border-radius: 8px;
  background-color: ${props => props.theme.pointBlue};

  &:hover {
    cursor: pointer;
  }
`;


const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: 120px;
  height: 1px;

  margin: 0 16px 0 16px;
  border: 1px solid ${props => props.theme.line};
`;

const ResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 113px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: ${props => props.theme.line};
`;

const ListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 24px;

  width: 100%;
`;

const PriceTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  gap: 4px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;